'use strict';
var isObject = require('../internals/is-object');

var $String = String;
var $TypeError = TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw new $TypeError($String(argument) + ' is not an object');
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/internals/an-object.js
// module id = 39
// module chunks = 13